/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'CustomSensorTooltip';

export const classes = {
  date: `${PREFIX}-date`,
  content: `${PREFIX}-content`,
  amount: `${PREFIX}-amount`,
  divider: `${PREFIX}-divider`,
  list: `${PREFIX}-list`,
  listItem: `${PREFIX}-list-item`,
};

export const StyledBox = styled(Box)(({theme}) => ({
  backgroundColor: '#E3E3E3',
  borderRadius: '8px',

  [`& .${classes.date}`]: {
    color: '#202020',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '14px',
  },

  [`& .${classes.amount}`]: {
    color: '#202020',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '14px',
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
  },

  [`& .${classes.divider}`]: {
    width: '100%',
    height: '1px',
    background: theme.palette.figma_gray_middle_dark?.main,
  },

  [`& .${classes.content}`]: {
    padding: theme.spacing(4),
  },

  [`& .${classes.list}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },

  [`& .${classes.listItem}`]: {
    display: 'flex',
    gap: theme.spacing(4),
    justifyContent: 'space-between',
  },
}));
